import './bootstrap';

import { createSSRApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from 'ziggy-js';
import { createPinia } from 'pinia';
import { config as fontAwesomeConfig } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { hasPermission } from './helpers';
import { initSentry } from './sentry-browser.mjs';

fontAwesomeConfig.autoAddCss = false;

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

createInertiaApp({
    progress: {
        delay: 0,
        color: '#29d',
        includeCSS: true,
        showSpinner: true,
    },
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        const app = createSSRApp({ render: () => h(App, props) });

        initSentry({ app });

        app.use(plugin)
            .use(ZiggyVue, Ziggy)
            .use(createPinia())
            .component('font-awesome-icon', FontAwesomeIcon);

        app.config.globalProperties.$can = hasPermission;

        return app.mount(el);
    },
});
